import styled from 'styled-components';
export var Wrapper = styled.div.withConfig({
  displayName: "Limitstyles__Wrapper",
  componentId: "keen-query-creator__sc-1l6julh-0"
})(["&&&{display:inline-block;position:relative;}"]);